export default function formatPrice(
  price: number | bigint,
  isFractionDigitsDisabled: boolean = true,
  currencySymbol: string = 'руб'
) {
  const setup: Record<string, number> = {}

  if (isFractionDigitsDisabled) {
    setup.minimumFractionDigits = 0
    setup.maximumFractionDigits = 0
  }

  const formatter = new Intl.NumberFormat('ru-RU', setup)

  return formatter.format(price) + ' ' + currencySymbol
}
